import { InputLabel, MenuItem } from '@mui/material';
import { memo } from 'react';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';

interface LawyerListComponentProps {
  disabled?: boolean;
  value: string;
  onChange: (enrollment?: string) => void;
  error?: boolean;
  label?: string;
  id?: string;
}

const list = Object.freeze([
  {
    id: 'A',
    value: 'Avvocato',
  },
  {
    id: 'N',
    value: 'Notaio',
  },
]);

const LawyerListComponent = ({
  disabled,
  onChange,
  value,
  error,
  label = 'Avvocato/Notaio',
  id = 'lawyer-list',
}: LawyerListComponentProps): React.ReactElement => {
  const idTag = `${id}-${label}`;

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={idTag}>
        {label}
      </InputLabel>
      <PmiSelect
        labelId={idTag}
        id={id}
        name={id}
        value={value}
        label={label}
        onChange={(event) => {
          const selectedValue = event.target.value;
          onChange(selectedValue);
        }}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {list.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

LawyerListComponent.displayName = 'Lawyer list component';

const LawyerList = memo(LawyerListComponent);

export default LawyerList as typeof LawyerListComponent;
